module.exports = __webpack_public_path__ + "img/SC8-cover-costs.20a783c0.png";